export default {
    claims: {
        name: "Nome",
        description: "Descrizione",
        CHAT: {
            cancreate: "Puoi creare una chat",
            canedit: {
                title: "Puoi modificare il titolo",
                users: "Puoi modificare gli utenti di una chat"
            },
            enabled: "Abilita modulo",
        },
        DASHBOARD: {
            cancreate: "Puoi creare una dashboard",
            candelete: "Puoi cancellare una dashboard",
            canedit: "Puoi modificare una dashboard",
            canseeall: "Puoi vedere tutte le dashboard",
            enabled: "Abilita modulo",
        },
        DATASOURCE: {
            cancreate: "Puoi creare una sorgente dati esterna",
            canedit: "Puoi modificare una sorgente dati esterna",
            enabled: "Abilita modulo",
        },
        DYNAMICRULES: {
            enabled: "Abilita modulo",
        },
        GROUPS: {
            canaddusers: "Puoi aggiungere utenti ai gruppi",
            cancreate: "Puoi creare gruppi",
            candelete: "Puoi cancellare un gruppo",
            canedit: "Puoi modificare un gruppo",
            canremoveusers: "Puoi rimuovere un utente dal gruppo",
            canseeothergroups: "Puoi vedere tutti i gruppi",
            enabled: "Abilita modulo",
            canmanageclaims: "Puoi gestire i permessi",
            cantransferclaims: "Puoi trasferire i permessi",
            canseeclaims: "Puoi vedere i permessi"
        },
        ISSUES: {
            canadd: {
                groups: "Puoi aggiungere un gruppo di Issue",
            },
            canarchive: "Puoi archiviare issue",
            canchange: {
                assegnee: "Puoi assegnare una issue",
                group: "Puoi cambiare gruppo ad una issue",
                priority: "Puoi cambiare priorità ad una issue",
                status: "Puoi cambiare stato di un issue",
            },
            canconvert: "Puoi convertire una issue in task",
            cancreate: "Puoi creare issue",
            candelete: "Puoi cancellare issue",
            canedit: {
                customfields: "Puoi modificare i campi aggiuntivi di una issue",
                groups: "Puoi modificare i gruppi di issue",
                others: "Puoi modificare issue assegnate ad altri",
                own: "Puoi modificare issue assegnate a te o create da te",
                states: "Puoi modificare gli stati delle issue",
            },
            canextract: { report: "Puoi esportare in CSV le issue", },
            cansee: { all: "Puoi vedere tutte le issue", },
            enabled: "Abilita modulo",
        },
        TEAMS: {
            canaddusers: "Puoi aggiungere utenti ad un team",
            cancreate: "Puoi creare un team",
            candelete: "Puoi cancellare un team",
            canedit: "Puoi modificare un team",
            canremoveusers: "Puoi rimuovere utenti da un team",
            enabled: "Abilita modulo",
        },
        USERS: {
            canchangepassword: "Puoi modificare la password",
            cancreate: "Puoi creare utenti",
            candelete: "Puoi cancellare utenti",
            canedit: "Puoi modificare utenti",
            enabled: "Abilita modulo",
            canseeonlyfrommyteams: "Puoi vedere solo dal team"
        },
        WORKSPACE: {
            cancreate: "Puoi creare workspace",
            cancreateExpiring: "Puoi agggiungere una scadenza",
            candelete: "Puoi cancellare una workspace",
            canedit: "Puoi modificare una workspace",
            caneditExpiring: "Puoi modificare la scadenza",
            canseeExpiring: "Puoi vedere le workspace scadute",
            enabled: "Abilita modulo",
        },
        ALLEGATI: {
            CanCreate: "Puoi creare allegati",
            CanDelete: "Puoi cancellare allegati",
            CanRead: "Puoi visualizzare gli allegati",
        },
        ESRISERVICE: {
            CanPushMonitoraggio: "Puoi aggiungere geometrie di monitoraggio",
            CanReadEcografico: "Puoi leggere i dati dall'ecografico",

        },
        LAYERS: {
            ALL: {
                CanCreate: "Puoi aggiungere i layer",
                CanRead: "Puoi visualizzare i layer",
                CanEdit: "Puoi modificare i layer"
            },
            ZNM: {
                CanCreate: "Puoi aggiungere i layer di Zona non Metanizzata",
                CanRead: "Puoi visualizzare i layer di Zona non Metanizzata",
                CanEdit: "Puoi modificare i layer di Zona non Metanizzata"
            },
            CDU: {
                CanCreate: "Puoi aggiungere i layer di Certificazione destinazione urbanistica",
                CanRead: "Puoi visualizzare i layer di Certificazione destinazione urbanistica",
                CanEdit: "Puoi modificare i layer di Certificazione destinazione urbanistica"
            },
            SCAVI: {
                CanCreate: "Puoi aggiungere i layer di Scavo",
                CanRead: "Puoi visualizzare i layer di Scavo",
                CanEdit: "Puoi modificare i layer di Scavo"
            },
            SPECCHI: {
                CanCreate: "Puoi aggiungere i layer di Specchio",
                CanRead: "Puoi visualizzare i layer di Specchio",
                CanEdit: "Puoi modificare i layer di Specchio"
            }
        },
        INTEGRAZIONI: {
            CanDelete: "Puoi cancellare integrazioni",
            CanRead: "Puoi visualizzare integrazioni",
            CanRequest: "Puoi richiedere integrazioni",
            CanResponse: "Puoi rispondere alle integrazioni",
        },
        ISTANZE: {
            ALL: {
                CanRead: "Puoi visualizzare le tue istanze",
                CanReadAll: "Puoi visualizzare tutte le istanze",
                CanSignatureOnPurpose: "Puoi richiedere la firma dell'istanze",
                CanSignatureRequire: "Puoi caricare l'istanza firmata",
                FinishProcedure: "Puoi concludere il procedimento di istanza",
            },
            CDU: {
                CanChangeState: "Puoi cambiare lo stato dell'istanza di Certificazione destinazione urbanistica",
                CanCreate: "Puoi aggiungere un istanza di Certificazione destinazione urbanistica",
                CanDeprecate: "Puoi deprecare un istanza di Certificazione destinazione urbanistica",
                CanEdit: "Puoi modificare un istanza di Certificazione destinazione urbanistica",
                CanProtocolIn: "Puoi richiedere la protocollazione in ingresso di un istanza di Certificazione destinazione urbanistica",
                CanRead: "Puoi visualizzare le istanze di Certificazione destinazione urbanistica",
            },
            SCAVI: {
                CanChangeState: "Puoi cambiare lo stato dell'istanza di Scavo",
                CanCreate: "Puoi aggiungere un istanza di Scavo",
                CanDeprecate: "Puoi deprecare un istanza di Scavo",
                CanEdit: "Puoi modificare un istanza di Scavo",
                CanProtocolIn: "Puoi richiedere la protocollazione in ingresso di un istanza di Scavo",
                CanRead: "Puoi visualizzare le istanze di Scavo",
            },
            SPECCHI: {
                CanChangeState: "Puoi cambiare lo stato dell'istanza di Specchio",
                CanCreate: "Puoi aggiungere un istanza di Specchio",
                CanDeprecate: "Puoi deprecare un istanza di Specchio",
                CanEdit: "Puoi modificare un istanza di Specchio",
                CanProtocolIn: "Puoi richiedere la protocollazione in ingresso di un istanza di Specchio",
                CanRead: "Puoi visualizzare le istanze di Specchio",
            },
            ZNM: {
                CanChangeState: "Puoi cambiare lo stato dell'istanza di Zona non Metanizzata",
                CanCreate: "Puoi aggiungere un istanza di Zona non Metanizzata",
                CanDeprecate: "Puoi deprecare un istanza di Zona non Metanizzata",
                CanEdit: "Puoi modificare un istanza di Zona non Metanizzata",
                CanProtocolIn: "Puoi richiedere la protocollazione in ingresso di un istanza di Zona non Metanizzata",
                CanProtocolOut: "Puoi richiedere la protocollazione in uscita di un istanza di Zona non Metanizzata",
                CanRead: "Puoi visualizzare le istanze di Zona non Metanizzata",
            }            
        },
        PAGAMENTI: {
            CanDelete: "Puoi cancellare pagamenti",
            CanRead: "Puoi visualizzare pagamenti",
            CanRequest: "Puoi richiedere pagamenti",
            CanResponse: "Puoi rispondere alle pagamenti",
        },
        PARERIINTERNI: {
            CanDelete: "Puoi cancellare pareri interni",
            CanRead: "Puoi visualizzare pareri interni",
            CanRequest: "Puoi richiedere pareri interni",
            CanResponse: "Puoi rispondere ai pareri interni",
        },
        COMUNICAZIONI: {
            CanDelete: "Puoi cancellare comunicazioni",
            CanRead: "Puoi visualizzare comunicazioni",
            CanRequest: "Puoi richiedere comunicazioni",
        },
        TIMELINE: {
            CanRead: "Puoi visualizzare i log delle operazioni"
        },
        ATTRIBUTIPROTOCOLLAZIONE: {
            ALL: {
                CanRead: "Puoi visualizzare gli attributi della Protocollazione",
                CanEdit: "Puoi modificare gli attributi della Protocollazione"
            },
            ZNM: {
                CanRead: "Puoi visualizzare gli attributi della Protocollazione di Zona non Metanizzata",
                CanEdit: "Puoi modificare gli attributi della Protocollazione di Zona non Metanizzata"
            },
            CDU: {
                CanRead: "Puoi visualizzare gli attributi della Protocollazione di Certificazione destinazione urbanistica",
                CanEdit: "Puoi modificare gli attributi della Protocollazione di Certificazione destinazione urbanistica"
            },
            SCAVI: {
                CanRead: "Puoi visualizzare gli attributi della Protocollazione di Scavo",
                CanEdit: "Puoi modificare gli attributi della Protocollazione di Scavo"
            },
            SPECCHI: {
                CanRead: "Puoi visualizzare gli attributi della Protocollazione di Specchio",
                CanEdit: "Puoi modificare gli attributi della Protocollazione di Specchio"
            }
        }
    }
}